<template>
	<div
		class="text-separator-secondary h-full w-full opacity-50"
		v-html="parsePreloader(preloader)"
	></div>
</template>
<script setup lang="ts">
const parsePreloader = (preloader?: string) =>
	preloader
		? atob(preloader.replace('data:image/svg+xml;base64,', '')).replace(
				'<defs><linearGradient id="g" x1="-300%" x2="-200%" y1="0" y2="0"><stop offset="-10%" stop-opacity=".1"/><stop offset="30%" stop-opacity=".07"/><stop offset="70%" stop-opacity=".07"/><stop offset="110%" stop-opacity=".1"/><animate attributeName="x1" from="-300%" to="1200%" dur="3s" repeatCount="indefinite"/><animate attributeName="x2" from="-200%" to="1300%" dur="3s" repeatCount="indefinite"/></linearGradient></defs>',
				''
			)
		: ''

defineProps<{
	preloader: string
}>()
</script>
